import authStore from "@/store/auth.js";
import emitenteStore from "@/store/emitente.js";

export default {
  currentEmitente: emitenteStore.getEmitente,
  currentEmitenteIsComercio() {
    return this.currentEmitente.cnae == 47;
  },
  currentUser: authStore.getCurrentUser,
  emitente: emitenteStore.getEmitente /*deprecated*/,
  user: authStore.getCurrentUser /*deprecated*/,
};
